/*** IMPORTS FROM imports-loader ***/
var define = false;

import map from 'lodash/map';
import $ from 'jquery';
import 'slick-carousel';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUiDefault from 'photoswipe/dist/photoswipe-ui-default';

// eslint-disable-next-line import/prefer-default-export
export function initializeProductDetail($container) {
  //
  // Photos
  //

  const $bigSlides = $container.find('.big-slides');
  const $thumbSlides = $container.find('.thumb-slides');

  if ($bigSlides.length) {
    const opts = {
      infinite: true,
      lazyLoad: 'progressive',
      adaptiveHeight: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: $('#slider-prev').html(),
      nextArrow: $('#slider-next').html(),
      rows: 0,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
          },
        },
      ],
    };

    if ($thumbSlides.length) {
      opts.asNavFor = '.thumb-slides';
    }

    $bigSlides.slick(opts);

    //
    // PhotoSwipe
    //

    const pswpElement = document.querySelectorAll('.pswp')[0];

    const photos = map($container.data('photos'), photo => ({
      src: window.APP.context.site.files_url + photo.path,
      w: photo.width,
      h: photo.height,
    }));

    const options = {
      galleryUID: 1,
      index: 0,
      bgOpacity: 1,
      captionEl: false,
      fullscreenEl: false,
      shareEl: false,
      tapToClose: true,
      tapToToggleControls: false,
    };

    $bigSlides.on('click', '.slide', (ev) => {
      ev.preventDefault();
      options.index = $(ev.currentTarget).closest('.slick-slide').data('slick-index');
      const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUiDefault, photos, options);
      gallery.init();
    });
  }

  if ($thumbSlides.length) {
    $thumbSlides.slick({
      asNavFor: '.big-slides',
      focusOnSelect: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: $('#slider-prev').html(),
      nextArrow: $('#slider-next').html(),
      centerMode: true,
      centerPadding: '60px',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
          },
        },
      ],
    });

    $thumbSlides.on('click', '.slide', (ev) => {
      $thumbSlides.slick('slickGoTo', $(ev.currentTarget)
        .closest('.slick-slide')
        .data('slick-index'));
    });
  }
}

